import apiClient from './client';

/**
 * Click-driven equip via the unified substrate endpoint.
 * Wraps user_skill_tree_unlocks + drug_card_unlocks + card_progression +
 * equipment_state writes in one transaction server-side.
 *
 * Errors: 400 with detail string ("This card augments Vancomycin — equip ..."),
 * 400 on missing/unknown node_id, 400 during an active combat session.
 */
export async function equipSkillTreeNode(nodeId) {
  const { data } = await apiClient.post('/api/skill-tree/equip', { node_id: nodeId });
  return data;
}

/**
 * Click-driven unequip — clears the slot/keystone overlay but keeps the
 * underlying unlock records (unequip is a transient loadout choice).
 */
export async function unequipSkillTreeNode(nodeId) {
  const { data } = await apiClient.post('/api/skill-tree/unequip', { node_id: nodeId });
  return data;
}

/**
 * Read the player's skill-tree state (tree definition + node states +
 * equipped_drugs / equipped_keystone). Shares the ['player','skill-tree']
 * React Query cache with SkillTreeViewport (identical endpoint) so a surface
 * that only needs to WATCH equipped state (e.g. the forced first-equip gate)
 * subscribes by key without a redundant round-trip once the viewport has
 * populated the cache.
 */
export async function fetchSkillTreePlayerState() {
  const { data } = await apiClient.get('/api/skill-tree/player-state');
  return data;
}
